import './App.css';
import Home from './Components/Home';
import ProductList from './Components/Products/Products';
import { Routes, Route } from "react-router-dom";
import ProductDetailsPage from './Components/ProductDetails/ProductDetailPage';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import ForgotPassword from './Components/ForgotPassword';
import ProfilePage from './Components/Orders/ProfilePage';
import ProfileForm from './Components/Orders/ProfileForm';
import ProfileOrders from './Components/Orders/ProfileOrders';
import ProfileOrderDetails from './Components/Orders/ProfileOrderDetails';
import ProfileAddress from './Components/Orders/ProfileAddress';
import ProfileAddAddress from './Components/Orders/ProfileAddAddress';
import ProfileSettings from './Components/Orders/ProfileSettings';
import ResetPassword from './Components/ResetPassword';
import ChangePassword from './Components/ChangePassword';
import EmailVerified from './Components/EmailVerified';
import Wishlist from './Components/Wishlist/Wishlist';
import CartSection from './Components/CartSection';
import ProtectedRoute from './config/ProtectedRoute';
import GloginSuccess from './Components/loginsuccess';
import EmailVerificationPending from './Components/PendingVerification';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Terms from './Components/Terms';
import ContactUs from './Components/ContactUs';
import ShippingPolicy from './Components/ShippingPolicy';

import Cancallation from "./Components/Cancallation"
function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<ProductList />} />
      <Route path="/products/:id" element={<ProductDetailsPage />} />
      <Route path="/loginsuccess" element={<GloginSuccess />} />
      <Route path="/pendingverify" element={<EmailVerificationPending />} />

      

      <Route
        path="/wishlist"
        element={
          <ProtectedRoute>
            <Wishlist />
          </ProtectedRoute>
        }
      />

      <Route
        path="/cart"
        element={
          <ProtectedRoute>
            <CartSection />
          </ProtectedRoute>
        }
      />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/changepassword" element={<ChangePassword />} />
      <Route path="/emailverify" element={<EmailVerified />} />
      <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        >
        <Route index element={<ProfileForm />} />
        <Route path="orders" element={<ProfileOrders />} />
        <Route path="orders/:orderId" element={<ProfileOrderDetails />} />
        <Route path="address" element={<ProfileAddress />} />
        <Route path="add-address" element={<ProfileAddAddress />} />
        <Route path="settings" element={<ProfileSettings />} />
        
      </Route>
        <Route path="/Cancellation" element={<Cancallation />} />
       <Route path="/Terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/shipping-info" element={<ShippingPolicy/>} />

    </Routes>
  );
}

export default App;
